<app-breadcrumb></app-breadcrumb>
<div class="container" *ngIf="searchResponse$ | async as searchResponse">
     <div class="main-container-results">
          <p-accordion>
               <p-accordionTab header="Search Criteria">
                    <div class="card">
                         <div class="row">
                              <div class="col">
                                   <div class="card-label">Date:
                                        <span class="card-item"> {{formCopy?.date || "" | formatDate}}</span>
                                   </div>
                                   <div class="card-label">Start Date:
                                        <span class="card-item"> {{formCopy?.dateStart || "" | formatDate}}</span>
                                   </div>
                                   <div class="card-label">End Date:
                                        <span class="card-item"> {{formCopy?.dateEnd || "" | formatDate}}</span>
                                   </div>
                                   <div class="card-label">Sequence:
                                        <span class="card-item"> {{formCopy?.sequenceNumber || ""}}</span>
                                   </div>
                                   <div class="card-label">Equipment:
                                        <span class="card-item"> {{convertEquipmentTypeCode(formCopy?.equipmentNumber ||
                                             "")}}</span>
                                   </div>
                                   <div class="card-label">Equip. Nose#:
                                        <span class="card-item"> {{formCopy?.equipmentReg || ""}}</span>
                                   </div>
                                   <div class="card-label">Station:
                                        <span class="card-item"> {{formCopy?.stationCode | uppercase}}</span>
                                   </div>
                              </div>
                              <div class="col">
                                   <div class="card-label">Flight#:
                                        <span class="card-item"> {{formCopy?.flightNumber?.toString() || ""}}</span>
                                   </div>
                                   <div class="card-label">Seat Position:
                                        <span class="card-item"> {{formCopy?.seat || ""}}</span>
                                   </div>
                                   <div class="card-label">First Name:
                                        <span class="card-item"> {{formCopy?.crewFirstName || ""}}</span>
                                   </div>
                                   <div class="card-label">Last Name:
                                        <span class="card-item"> {{formCopy?.crewLastName || ""}}</span>
                                   </div>
                                   <div class="card-label">Employee#:
                                        <span class="card-item"> {{formCopy?.employeeNumber || ""}}</span>
                                   </div>
                                   <div class="card-label">Route:
                                        <span class="card-item" 
                                        *ngIf="formCopy?.departureStation && formCopy?.arrivalStation"> 
                                        {{formCopy?.departureStation || ""}}-{{formCopy?.arrivalStation || ""}}
                                   </span>
                                   </div>
                                   <div class="card-label">Date/Time Format:
                                        <span class="card-item"> {{appSettings?.dateTimeFormatDefault?.toUpperCase()}}</span>
                                   </div>
                                   
                              </div>
                         </div>
                    </div>
               </p-accordionTab>
          </p-accordion>
          <div class="pagination-container" *ngIf="searchResponse.response?.hasNext || page > 0">
               <div class="pagination-row">
                    @if (searchResponse.response?.hasNext || page > 0) {
                    <button class="chevron-btn pi pi-angle-left" (click)="onPrevClick()" [disabled]="page == 0">
                    </button>
                    }
                    <span class="footer-text">Page {{page + 1}}</span>
                    @if (searchResponse.response?.hasNext) {
                    <button class="chevron-btn pi pi-angle-right" (click)="onNextClick(searchResponse.response!)"
                         [disabled]="!searchResponse.response?.hasNext">
                    </button>
                    }
                    @else {
                    <button class="chevron-btn pi pi-angle-right" (click)="onNextClick(searchResponse.response!)"
                         [disabled]="!searchResponse.response?.hasNext">
                    </button>
                    }
               </div>
          </div>
          <div class="container-result-list">
               <div *ngFor="let sequence of searchResponse.response?.items, let i=index">
                    <div class="tb-header" (click)="onSequenceClicked(
                                   sequence, 
                                   i,
                                   searchResponse.response, 
                                   'search-result-seq')">
                         {{sequence.sequenceNumber}}
                    </div>

                    <div *ngFor="let duty of sequence.dutyPeriodSummaries">
                         <div *ngFor="let leg of duty.legs">
                              <app-flight-item
                                   (click)="searchResponse.response && onLegClicked(leg, sequence, searchResponse.response, 'search-result-leg')"
                                   [flightNumber]="leg.flightNumber" [aircraft]="leg.aircraft"
                                   [depStation]="leg.departureStation.code" [arrStation]="leg.arrivalStation.code"
                                   [depTimes]="leg.departure" [arrTimes]="leg.arrival"
                                   [flightTimeActual]="leg.flightTimeActual"
                                   [flightTimeScheduled]="leg.flightTimeScheduled" [isDeadhead]="leg.isDeadhead"
                                   [isCancelled]="leg.isCancelled">
                              </app-flight-item>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</div>